import React, { memo } from 'react';
import './styles.css';

/**
 * @param {{
 *    name: string;
 *    value: string | number;
 *    type: string;
 *    readOnly: boolean;
 * }} props
 */
export const Input = memo(({
  label = '',
  name,
  value,
  max,
  type = 'text',
  error = false,
  readOnly = false,
  disabled = false,
  required = false,
  message = '',
  className = '',
  labelClassName = '',
  inputClassName = '',
  placeholder = '',
  autoComplete = '',
  fontSize = '14',
  maxLength = undefined,
  onChange: handleChange = () => {},
  onKeyDown: handleKeyDown = () => {},
  onFocus: handleFocus = () => {},
  onBlur: handleBlur = () => {},
}) => (
  <>
    {
      label.length
        ? <label className={`input-label font-${fontSize} ${required ? 'm-r-1' : 'm-r-4'} ${labelClassName}`}>{label}</label>
        : null
    }

    {
      required && <span className='required font-24 m-r-4'>*</span>
    }

    <div className={`flex flex-column relative ${className}`}>
      <input
        type={type}
        name={name}
        value={value}
        max={max}
        maxLength={maxLength}
        readOnly={readOnly}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`input ${error ? 'error' : ''} font-${fontSize} ${inputClassName}`}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {
        message.length
          ? (
            <div className={`input-message absolute flex m-t-1 m-b-1 ${error ? 'error' : ''}`}>
              <span>{message}</span>
            </div>
          )
          : null
      }
    </div>
  </>
));

/**
 * @param {{
*    name: string;
*    value: string | number;
*    type: string;
*    readOnly: boolean;
* }} props
*/
export default Input;
